/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Unavailabletitle1Inputs */

const id_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak tersedia`)
};

const ms_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak tersedia`)
};

const da_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil utilgængelig`)
};

const de_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nicht verfügbar`)
};

const en_us2_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile unavailable`)
};

const es_es2_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil no disponible`)
};

const es_mx2_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil no disponible`)
};

const fil_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available ang profile`)
};

const fr_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil indisponible`)
};

const it_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo non disponibile`)
};

const hu_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nem elérhető`)
};

const nl_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel niet beschikbaar`)
};

const no_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil utilgjengelig`)
};

const pl_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil niedostępny`)
};

const pt_br2_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil indisponível`)
};

const pt_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil indisponível`)
};

const ro_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil indisponibil`)
};

const fi_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiili ei käytettävissä`)
};

const sv_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilen inte tillgänglig`)
};

const vi_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ không khả dụng`)
};

const tr_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil kullanılamıyor`)
};

const cs_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil není k dispozici`)
};

const bg_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профилът не е наличен`)
};

const ru_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль недоступен`)
};

const uk_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль недоступний`)
};

const ar_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملف الشخصي غير متاح`)
};

const hi_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल अनुपलब्ध`)
};

const th_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์ไม่พร้อมใช้งาน`)
};

const ja_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールは利用できません`)
};

const zh_cn2_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料不可用`)
};

const zh_hant1_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料無法使用`)
};

const ko_profile_errors_unavailabletitle1 = /** @type {(inputs: Profile_Errors_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필을 사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "Profile unavailable" |
*
* @param {Profile_Errors_Unavailabletitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_unavailabletitle1 = /** @type {((inputs?: Profile_Errors_Unavailabletitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Unavailabletitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_unavailabletitle1(inputs)
	if (locale === "ms") return ms_profile_errors_unavailabletitle1(inputs)
	if (locale === "da") return da_profile_errors_unavailabletitle1(inputs)
	if (locale === "de") return de_profile_errors_unavailabletitle1(inputs)
	if (locale === "en-US") return en_us2_profile_errors_unavailabletitle1(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_unavailabletitle1(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_unavailabletitle1(inputs)
	if (locale === "fil") return fil_profile_errors_unavailabletitle1(inputs)
	if (locale === "fr") return fr_profile_errors_unavailabletitle1(inputs)
	if (locale === "it") return it_profile_errors_unavailabletitle1(inputs)
	if (locale === "hu") return hu_profile_errors_unavailabletitle1(inputs)
	if (locale === "nl") return nl_profile_errors_unavailabletitle1(inputs)
	if (locale === "no") return no_profile_errors_unavailabletitle1(inputs)
	if (locale === "pl") return pl_profile_errors_unavailabletitle1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_unavailabletitle1(inputs)
	if (locale === "pt") return pt_profile_errors_unavailabletitle1(inputs)
	if (locale === "ro") return ro_profile_errors_unavailabletitle1(inputs)
	if (locale === "fi") return fi_profile_errors_unavailabletitle1(inputs)
	if (locale === "sv") return sv_profile_errors_unavailabletitle1(inputs)
	if (locale === "vi") return vi_profile_errors_unavailabletitle1(inputs)
	if (locale === "tr") return tr_profile_errors_unavailabletitle1(inputs)
	if (locale === "cs") return cs_profile_errors_unavailabletitle1(inputs)
	if (locale === "bg") return bg_profile_errors_unavailabletitle1(inputs)
	if (locale === "ru") return ru_profile_errors_unavailabletitle1(inputs)
	if (locale === "uk") return uk_profile_errors_unavailabletitle1(inputs)
	if (locale === "ar") return ar_profile_errors_unavailabletitle1(inputs)
	if (locale === "hi") return hi_profile_errors_unavailabletitle1(inputs)
	if (locale === "th") return th_profile_errors_unavailabletitle1(inputs)
	if (locale === "ja") return ja_profile_errors_unavailabletitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_unavailabletitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_unavailabletitle1(inputs)
	return ko_profile_errors_unavailabletitle1(inputs)
});
export { profile_errors_unavailabletitle1 as "profile.errors.unavailableTitle" }